<template lang="html">
  <div class="image-input">
    <input v-if="!prohibition"
           type="file"
           ref="fileInput"
           :accept="acceptContent"
           name="images[]"
           v-on:change="upload">
    <input type="hidden" name="images_ids[]" v-model="imageId" class="images_ids">
    <input type="hidden" name="video_ids[]" v-model="videoId">
    <div class="image-cell" :style="cropImage" v-if="!input.imagePath"></div>
    <img class="small_image" style="max-width: 150px; max-height: 150px" data-rjs="2" v-if="input.imagePath"
         :src="input.imagePath">
    <img class="small_image" style="display: none; max-width: 150px; max-height: 150px" data-rjs="2" v-else>
    <span class="video-name">{{ this.videoName }}</span>
    <button v-if="!prohibition" type="button" @click="browseImage">Upload Image {{ disabledVideo ? '' : 'or Video' }}
    </button>

    <ImageCredit v-if="input.type === 'image' && ((!prohibition && cropImage) || input.imagePath || input.image || input.imageId)" v-model="hyperlink" @updated="updatedHyperlink"/>

    <button v-if="(!prohibition && cropImage) || input.imagePath || input.image || input.imageId" class="delete-image" type="button"
            @click="deleteInput">Delete
    </button>
    <strong :class="{ loading: errorClassLoading, 'text-danger': errorClassDanger }">{{ errorText }}</strong>
  </div>
</template>

<script>
import ImageCredit from './../ImageCredit';

export default {
  components: {
    ImageCredit,
  },

  props: ['input', 'prohibition', 'disabledVideo', 'entity'],

  data() {
    return {
      cropImage: '',
      acceptContent: 'image/png,image/jpeg' + (this.disabledVideo ? '' : ',video/*,video/x-flv'),
      defaultImage: 'images/default/100x100/ci-logo.png',
      imageId: null,
      videoId: null,
      filled: false,
      videoName: '',
      errorText: '',
      hyperlink: {
        text: ''
      },
      errorClassLoading: false,
      errorClassDanger: false,
    };
  },

  mounted() {
    if (this.input.hyperlink) {
      this.hyperlink = this.input.hyperlink;
    }

    if (this.input.type === 'image' && this.input.image) {
      this.input.cropPublicPath = this.input.image;
      this.handleCustomImage(this.input);

      return;
    }

    if (this.input.type === 'video') {
      this.videoId = this.input.videoId;
      this.cropImage = "background-image: url('/" + this.defaultImage + "')";
      this.videoName = this.input.videoName;
      this.filled = true;
    }

    this.imageId = this.input.imagePath ? this.input.id : this.imageId;
  },

  methods: {
    browseImage() {
      $(this.$refs.fileInput).click();
    },

    upload() {
      this.errorClassDanger = false;
      this.errorClassLoading = true;
      this.errorText = 'Uploading';

      let formData = new FormData();
      let content = this.$refs.fileInput.files[0];

      if (!(content.type.match('image.*') || content.type.match('video.*'))) {
        this.clearFiles();

        return;
      }

      if (content.type.match('image.*')) {
        formData.append('image', content);

        this.uploadImage(formData);

        return;
      }

      if (content.type.match('video.*')) {
        formData.append('video', content);

        this.uploadVideo(formData, content);
      }
    },

    deleteInput() {
      this.$emit('inputDeleted', this.input);
    },

    handleCustomImage(data) {
      let node = $(this.$el);

      node.find('.image-cell').css('display', 'none');
      node.find('.small_image').css('display', 'inline-block');
      node.find('.small_image').attr('src', data.cropPublicPath);
    },

    uploadImage(formData) {
      //Additional data for interviews images or news images
      let type = $('#entity_type').val();

      let isInterview = (type == 'interview');
      let isNews = (type == 'news');

      if (isInterview || isNews) {
        formData.append('entity_type', type + '_image');
        formData.append('file_id', $(this.$el).find('.images_ids').val());
      }
      //

      axios.post('/ajax/image/upload', formData,
        {
          headers: {'content-type': 'multipart/form-data'}
        })
        .then((response) => {
          if (isInterview || isNews) {
            this.handleCustomImage(response.data);
          }

          this.errorText = '';
          this.errorClassLoading = false;

          if (isInterview || isNews) {
            this.imageId = response.data.file_id;
          } else {
            this.imageId = response.data.id;
          }

          if (!isInterview && !isNews) {
            this.cropImage = "background-image: url('/" + response.data.image + "')";
          }

          this.videoName = '';

          if (!this.filled) {
            this.filled = true;
            this.$emit('imageUploaded', {
              type: 'image',
              imageId: this.file_id ? this.file_id : this.imageId,
              oldImageId: this.input.imageId,
            });
          } else {
            this.$emit('imageChanged', {
              type: 'image',
              imageId: this.file_id ? this.file_id : this.imageId,
              oldImageId: this.input.imageId,
              videoId: this.videoId
            });

            this.videoId = null;
          }

          this.clearFiles();
        })
        .catch(() => {
          this.errorClassDanger = true;
          this.errorClassLoading = false;

          this.setError({error: this.getErrorMessageByEntity()});

          this.clearFiles();
        });
    },

    uploadVideo(formData, content) {
      axios.post('/ajax/video/upload', formData,
        {
          headers: {'content-type': 'multipart/form-data'}
        })
        .then((response) => {
          this.errorText = '';
          this.errorClassLoading = false;

          this.videoId = response.data;
          this.videoName = content.name;
          this.cropImage = "background-image: url('/" + this.defaultImage + "')";

          if (!this.filled) {
            this.filled = true;

            this.$emit('imageUploaded', {
              type: 'video',
              videoId: this.videoId,
              oldVideoId: this.input.videoId
            });
          } else {
            this.$emit('imageChanged', {
              type: 'video',
              videoId: this.videoId,
              oldVideoId: this.input.videoId,
              imageId: this.imageId
            });

            this.imageId = null;
          }

          this.clearFiles();
        })
        .catch((error) => {
          this.errorClassDanger = true;
          this.errorClassLoading = false;

          this.setError(error.response.data);

          this.clearFiles();
        });
    },

    clearFiles() {
      this.$refs.fileInput.value = "";
    },

    setError(data) {
      if (data.error) {
        this.errorText = data.error;

        return;
      }

      this.errorText = data.errors.video[0];
    },

    getErrorMessageByEntity() {
      let message = '';

      switch (this.entity) {
      case 'interview':
        message = 'Images should be at least 700px wide';

        break;

      default:
        message = 'Please upload correct image (.JPG, .PNG, 700x700px minimum)';
      }

      return message;
    },

    updatedHyperlink(val) {
      this.$emit('imageChangedHyperlink', {
        type: 'image',
        imageId: this.file_id || this.imageId || this.input.imageId,
        oldImageId: this.input.imageId,
        videoId: this.videoId,
        hyperlink: val,
      });

      this.hyperlink = val;
    }
  }
};
</script>

<style scoped>
  .video-name {
    position: absolute;
    left: 130px;
    font-weight: bold;
  }

  button {
    margin-top: 30px;
  }
</style>
